import { location, overrideDomain, site } from '@/infrastructure/Configuration'

const useHttp = async (path, options) => {
  const baseUrl = overrideDomain || ''

  const defaultOptions = {
    headers: {
      'Accept-Language': location,
      Site: site,
      'Content-Type': 'application/json'
    }
  }

  const apiOptions = {
    ...options,
    origin: undefined
  }

  const response = await fetch(`${baseUrl}${path}`, {
    ...defaultOptions,
    ...apiOptions,
    headers: {
      ...defaultOptions.headers,
      ...options?.headers
    }
  })

  return await response.json()
}

export const useGet = async (path, options) => {
  return useHttp(path, { method: 'GET', ...options })
}

export const usePost = async (path, options) => {
  return useHttp(path, { method: 'POST', ...options })
}

export const useApi = () => ({
  get: useGet,
  post: usePost
})
